import React, { useEffect, useState } from "react";
import { Table, Card,Modal,Row,Col,Button } from "react-bootstrap";
import { Link,NavLink } from "react-router-dom";
import Sidebar from "../../components/Sidebar";
import Header from "../../components/Header";
import "./HRCreation.css";
import API from '../../Utils/Api';
import loader from '../../assests/loader.gif';
import { gettoastsuccess } from '../../Utils/Common';

/*const data = [
  { firstName: "John", lastName: "Doe", title: "Sales Manager", department: "Sales", level: "Senior", email: "john.doe@bluefaucet.com", state: "CA", city: "Los Angeles", zipCode: "90001", salesperson: 5, active: "Yes", loginId: "jdoe001", password: "*****" },
  { firstName: "Sarah", lastName: "Smith", title: "HR specialist", department: "Human Resource", level: "Mid", email: "sarah.smith@bluefaucet.com", state: "TX", city: "Austin", zipCode: "73301", salesperson: 2, active: "Yes", loginId: "ssmith002", password: "*****" },
  { firstName: "James", lastName: "Brown", title: "IT Technician", department: "IT", level: "Junior", email: "james.brown@bluefaucet.com", state: "NY", city: "New York", zipCode: "1001", salesperson: 1, active: "No", loginId: "jbrown003", password: "*****" },
  { firstName: "Emma", lastName: "Wilson", title: "Marketing Lead", department: "Marketing", level: "Senior", email: "emma.wilson@bluefaucet.com", state: "FL", city: "Miami", zipCode: "33101", salesperson: 4, active: "No", loginId: "ewilson004", password: "******" },
  { firstName: "Micheal", lastName: "Jognhson", title: "Account Manager", department: "Finance", level: "Senior", email: "michael.johnson@bluefaucet.com", state: "IL", city: "Chicago", zipCode: "60601", salesperson: 3, active: "Yes", loginId: "mjohnson005", password: "****" },
  { firstName: "Olivia", lastName: "Martinez", title: "Software Engineer", department: "IT", level: "Mid", email: "olivia.martinez@bluefaucet.com", state: "CA", city: "San Francisco", zipCode: "94101", salesperson: 0, active: "No", loginId: "omartinez006", password: "******" },
  { firstName: "William", lastName: "Davis", title: "Customer Support", department: "Support", level: "Mid", email: "william.davis@bluefaucet.com", state: "NV", city: "Las Vegas", zipCode: "94101", salesperson: 1, active: "No", loginId: "wdavis007", password: "*****" },
  { firstName: "Sophia", lastName: "Taylor", title: "Project Coordinator", department: "Project Management", level: "Junior", email: "sophia.taylor@bluefaucet.com", state: "WA", city: "Seattle", zipCode: "88901", salesperson: 2, active: "Yes", loginId: "staylor008", password: "******" },
  { firstName: "David", lastName: "Anderson", title: "Business Analyst", department: "Business Analysis", level: "Mid", email: "david.anderson@bluefaucet.com", state: "CO", city: "Denver", zipCode: "98101", salesperson: 3, active: "Yes", loginId: "danderson009", password: "*******" },
  { firstName: "Mia", lastName: "Thomas", title: "Graphic Designer", department: "Marketing", level: "Senior", email: "mia.thomas@bluefaucet.com", state: "FL", city: "Orlando", zipCode: "80201", salesperson: 0, active: "Yes", loginId: "mthomas010", password: "******" },
  { firstName: "John", lastName: "Doe", title: "Director", department: "Management", level: "Senior", email: "john.doe@bluefaucet.com", state: "CA", city: "Los Angeles", zipCode: "32801", salesperson: 2, active: "Yes", loginId: "jdoe011", password: "********" },
  { firstName: "Sarah", lastName: "Smith", title: "Manager", department: "Management", level: "Senior", email: "sarah.smith@bluefaucet.com", state: "TX", city: "Austin", zipCode: "73301", salesperson: 7, active: "No", loginId: "ssmith012", password: "********" }
];*/

const HRCreation = () => {

  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(false);
  const [id, setId] = useState();
  const [hr, setHr] = useState([]);

  const [keyword, setKeyword] = useState('');
  const [sortOrder, setSortOrder] = useState("asc");

  const [isMobile, setIsMobile] = useState(false);
  const [payAccordionOpen, setPayAccordionOpen] = useState(true);

  //const [rowsPerPage, setRowsPerPage] = useState(12);
  //const [currentPage, setCurrentPage] = useState(1);

  //const totalPages = Math.ceil(hr.length / rowsPerPage);

  /*const currentData = hr.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );*/

  /*const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };*/

  /*const handleRowsChange = (e) => {
    setRowsPerPage(parseInt(e.target.value));
    setCurrentPage(1);
  };*/

  useEffect(() => {
    document.title = `HR-Creation | bluefaucet`;
    document.getElementById("bodywrap").className = "infr";

    const handleResize = () => {
      setIsMobile(window.innerWidth < 767);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };

  }, []);

  useEffect(() => {
    /* Start get HR */
    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    API.post('backoffice_all_user', formData)
      .then(response => {
        setLoading(false);
        if (response.data.status === 0) {

        } else {
          setHr(response.data.data);
        }
      }).catch(error => {

      });
    /* End get HR */
  }, []);

  const handleSort = () => {
    setLoading(true);
    var ascdesc = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(ascdesc);
    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('order_by', ascdesc);
    formData.append('keyword', keyword);
    API.post('backoffice_all_user', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setHr(response.data.data);
        }
      }).catch(error => {
        setLoading(false);
      });
  };
  const handleInputChangeauto = (event) => {
    var keyword = event.target.value;
    setKeyword(keyword);
    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('order_by', sortOrder);
    formData.append('keyword', keyword);
    API.post('backoffice_all_user', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setHr(response.data.data);
        }
      }).catch(error => {
        setLoading(false);
      });
  }

  /* Start show delete varification modal */
   const handleShow = (id) => {
      setId(id);
      setShow(true);
   }
   /* End show delete varification modal */
   /* Start close delete varification modal */
   const handleClose = () => setShow(false);
   /* End close delete varification modal */
   /* Start delete notification */
   const handleDelete = () => {
      setLoading(true);
      setShow(false);
      let formData = new FormData();
      formData.append('token', localStorage.getItem("token"));
      formData.append('id', id);
      API.post('backoffice_employee_delete', formData)
         .then(response => {
            setLoading(false);
            if (response.data.status === 0) {

            } else {
              gettoastsuccess(response.data.message, '/hr-creation');
            }
         }).catch(error => {

         });
   }
   /* End delete notification */

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <Sidebar />

          <div className="col-md-9 col-lg-9 col-xl-10 col-xxl-10 ">
            <Header />
            <div className="row">
              <div className="content">
                <div className="row">
                  <div className="col-12 holisti okhas">
                    <div className="d-flex align-items-center justify-content-between gap-3 flex-wrap mb-3">
                      <h1 className="d-none d-md-block mb-0">HR Employee Backoffice Account Setup</h1>
                      <div className="biola">
                        <Link to={process.env.REACT_APP_BASE_URL + "create-account"} className="submit-btn mb-0">Create an account</Link>
                      </div>
                    </div>
                    <Card>
                      <div className="d-flex align-items-center gap-3 mb-2 mb-lg-0 justify-content-end">
                        <div className="d-flex align-items-center justify-content-md-start w-md-auto">
                          <div className="flex-grow-1 ms-lg-3 ms-0 me-2">
                            <div className="input-group">
                              <div className="input-group-text border-end-0">
                                <img
                                  src={process.env.REACT_APP_BASE_URL + 'assests/images/se-2.png'}
                                  alt="Search Icon"
                                  className="img-fluid"
                                />
                              </div>
                              <input
                                type="text"
                                className="form-control border-start-0 ps-0"
                                placeholder="Search"
                                value={keyword}
                                onChange={handleInputChangeauto}
                              />
                            </div>
                          </div>
                          <button type="button" className="sloti" onClick={handleSort}>
                            <img src={process.env.REACT_APP_BASE_URL + 'assests/images/sort.png'} alt="Sort" className="img-fluid me-2" />
                            Sort {sortOrder === "asc" ? "(A-Z)" : "(Z-A)"}
                          </button>
                        </div>
                      </div>
                      <div className="table-ro mt-2 d-none d-md-block">
                        <Table
                          responsive
                          className="table-no-last-border mb-0"
                        >
                          <thead className="table">
                            <tr className="custom-header">
                              <th className="lft ghed">First Name</th>
                              <th className="ghed">Last Name</th>
                              <th className="ghed">Job Title</th>
                              <th className="ghed">Department</th>
                              <th className="ghed">Level</th>
                              <th className="ghed">Email</th>
                              <th className="ghed">City or State</th>
                              <th className="ghed">Zip Code</th>
                              <th className="ghed">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {hr.map((item, index) => (
                              <tr key={index}>
                                <td className="lef">{item.first_name}</td>
                                <td><Link to={process.env.REACT_APP_BASE_URL + "edit-account/" + item.id}>{item.last_name}</Link></td>
                                <td>{item.job_title}</td>
                                <td>{item.department_name}</td>
                                <td>{item.level_name}</td>
                                <td>{item.company_email}</td>
                                <td>{item.city_or_state}</td>
                                <td>{item.zipcode}</td>
                                <td>
                                  {item.level !== 7 ? (
                                    <Link to="#" onClick={() => handleShow(item.id)}>Delete</Link>
                                  ) : (
                                    '-'
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>

                      <div className="col-12 d-flex align-items-center justify-content-between firsty d-md-none"
                        onClick={() => isMobile && setPayAccordionOpen(!payAccordionOpen)}
                        style={{ cursor: isMobile ? "pointer" : "default" }}
                      >
                        <h5>HR Employee Backoffice Account Setup</h5>
                        {isMobile && (
                          <img
                            src={
                              process.env.REACT_APP_BASE_URL +
                              (payAccordionOpen ? "assests/images/aco-up.png" : "assests/images/aco-down.png")
                            }
                            alt="Toggle Arrow"
                          />
                        )}
                      </div>
                      {(!isMobile || payAccordionOpen) && (
                        <>
                          <div className="d-md-none mb-3 ev-mobilex okchavo">
                            {hr.map((item, index) => (
                              <div
                                key={index}
                                className="col-12 mb-3 main"
                              >
                                <div className="d-flex justify-content-between align-items-center fir gap-2">
                                  <div className="sdtre">{item.first_name} {item.last_name}</div>
                                  <div className="poj">
                                    {item.department_name}
                                  </div>
                                </div>

                                <div className="fir mb-2">
                                  <div className="fidu">{item.job_title} - {item.level_name}</div>
                                </div>

                                <div className="phony d-flex justify-content-between align-items-center mb-2">
                                  <div><img src={process.env.REACT_APP_BASE_URL + 'assests/images/prifile.png'} alt={item.first_name} className="me-2" />{item.id}</div>
                                  {/*<div className={`fidu ${item.status === 1 ? "active-status" : "inactive-status"}`}>
                                        {item.status === 1 ? "Active" : "Inactive"}
                                      </div>*/}
                                </div>

                                <div className="phony d-flex align-items-center mb-2"><img src={process.env.REACT_APP_BASE_URL + 'assests/images/emiyy.png'} alt={item.first_name} className="me-2" />{item.company_email}</div>
                                <div className="phony d-flex justify-content-between align-items-center">
                                  <div><img src={process.env.REACT_APP_BASE_URL + 'assests/images/location.png'} alt={item.first_name} className="me-2" />{item.city_or_state}, {item.zipcode}</div>
                                  <div>{item.level !== 7 ? (
                                    <Link to="#" onClick={() => handleShow(item.id)}>Delete</Link>
                                  ) : null}</div>
                                </div>
                              </div>
                            ))}
                          </div>
                          {/*} <div className="d-flex flex-column flex-md-row justify-content-between align-items-center px-2 nation gap-2 mt-4">
                              <div className="d-flex align-items-center gap-2 mb-2 mb-md-0 mobile-flex">
                                <label>Show rows:</label>
                                <select
                                  value={rowsPerPage}
                                  onChange={handleRowsChange}
                                  className="form-select w-auto"
                                >
                                  <option value={12}>12 items</option>
                                  <option value={15}>15 items</option>
                                  <option value={20}>20 items</option>
                                  <option value={25}>25 items</option>
                                </select>
                              </div>

                              <nav>
                                <ul className="pagination pagination-sm mb-0">
                                  
                                  <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                    <button
                                      className="page-link"
                                      onClick={() => handlePageChange(currentPage - 1)}
                                    >
                                      &lt;
                                    </button>
                                  </li>

                                  
                                  <li className={`page-item ${currentPage === 1 ? "active" : ""}`}>
                                    <button className="page-link" onClick={() => handlePageChange(1)}>
                                      1
                                    </button>
                                  </li>

                                  
                                  {currentPage > 3 && totalPages > 5 && (
                                    <li className="page-item disabled">
                                      <span className="page-link">...</span>
                                    </li>
                                  )}

                                  
                                  {Array.from({ length: totalPages }, (_, i) => i + 1)
                                    .filter((page) => {
                                      return (
                                        page !== 1 &&
                                        page !== totalPages &&
                                        Math.abs(currentPage - page) <= 1
                                      );
                                    })
                                    .map((page) => (
                                      <li
                                        key={page}
                                        className={`page-item ${currentPage === page ? "active" : ""}`}
                                      >
                                        <button className="page-link" onClick={() => handlePageChange(page)}>
                                          {page}
                                        </button>
                                      </li>
                                    ))}

                                    
                                    {currentPage < totalPages - 2 && totalPages > 5 && (
                                      <li className="page-item disabled">
                                        <span className="page-link">...</span>
                                      </li>
                                    )}

                                    
                                    {totalPages > 1 && (
                                      <li
                                        className={`page-item ${currentPage === totalPages ? "active" : ""}`}
                                      >
                                        <button className="page-link" onClick={() => handlePageChange(totalPages)}>
                                          {totalPages}
                                        </button>
                                      </li>
                                    )}

                                    
                                    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                      <button
                                        className="page-link"
                                        onClick={() => handlePageChange(currentPage + 1)}
                                      >
                                        &gt;
                                      </button>
                                    </li>
                                </ul>
                              </nav>
                            </div>*/}
                        </>
                      )}
                    </Card>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ========== Delete Popup Start ========== */}
      <Modal show={show} onHide={handleClose} className="popupwrngcnt">
        <Modal.Header closeButton>
           <h3 className="mdlttltxt">Are you sure you want to delete?</h3>
        </Modal.Header>
        <Modal.Body>
           <Row>
              <Col className="btn-clr">
                 <NavLink to="#" onClick={handleDelete}><Button variant="">Yes</Button></NavLink>
              </Col>
              <Col className="btn-dv">
                 <NavLink to="#" onClick={handleClose}><Button variant="">No</Button></NavLink>
              </Col>
           </Row>
        </Modal.Body>
        <Modal.Footer className="d-none"></Modal.Footer>
     </Modal>
     {/* ========== Delete Popup End ========== */} 
      {loading && (
        <div className="loadingClass">
          <img src={loader} alt="loader" />
        </div>
      )}
    </>
  );
};

export default HRCreation;